import { IDM_POST_OPTIONS, IDM_API_URLS } from "../constants/constants";
import { getInterventionsAirbrake } from "./getInterventionsAirbrake";

const airbrake = getInterventionsAirbrake();

export async function updateInterventionStatus(
  userID: string,
  interventionName: string,
  site: string,
  vertical: string | undefined,
) {
  try {
    const response = await fetch(`${IDM_API_URLS()}/intervention/shown`, {
      ...IDM_POST_OPTIONS,
      body: JSON.stringify({
        system_user_id: userID,
        intervention_name: interventionName,
        site: site,
        vertical: vertical,
      }),
    });
    if (response.ok) return true;

    return false;
  } catch (error) {
    console.error("Error updating intervention status.", error);
    void airbrake.notify({
      error,
      params: {
        source: "mobius-interventions",
        interventionName: interventionName,
        userId: userID,
        site: site,
      },
    });
    return false;
  }
}
